import it from './it.js'
import en from './en.js'
import de from './de.js'

export const languages = {
     it: it,
     en: en,
     de: de,
}